import { useState, useEffect } from 'react';
import { buildAlarmSections } from '../component/common/popup/alarmSections';

export function useUserAlarm() {
    const [alarmData, setAlarmData] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [loading, setLoading] = useState(true);
    // 표출할 알람이 하나라도 있는지 여부 (홈 진입 시 빈 모달이 뜨지 않도록 사용)
    const [hasAlarm, setHasAlarm] = useState(false);

    useEffect(() => {
        const fetchAlarm = async () => {
            try {
                const res = await fetch('/commonapi/select_main_user_application_cnt.do', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                });
                const json = await res.json();

                if (json.hasError) {
                    alert(json.resultMessage);
                    return;
                }

                // 노출 여부는 모달이 실제로 그릴 항목이 있는지로 판단한다.
                // (조건을 여기서 따로 계산하면 모달 렌더 조건과 어긋난다)
                const alarmExists = buildAlarmSections(json).length > 0;

                setAlarmData(json);
                setHasAlarm(alarmExists);
                setShowPopup(alarmExists);
            } catch (e) {
                console.error('알람 조회 오류:', e);
            } finally {
                setLoading(false);
            }
        };

        fetchAlarm();
    }, []);

    return { alarmData, hasAlarm, showPopup, setShowPopup, loading };
}
